import { httpPdfService } from "../http-service";

const pdfStream = async (data: any) => {
  const pdfData = JSON.stringify(data);
  const response = await httpPdfService.post<any>(
    `/pdf-stream`,
    pdfData,
    {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    }
  );
  const pdfBlob = new Blob([response.data as unknown as BlobPart], {
    type: "application/pdf"
  });
  return window.URL.createObjectURL(pdfBlob);
};

const pdfFile = async (pdfData: any) => {
  const response = await httpPdfService.post<any>(
    `/pdf-file`,
    pdfData,
    {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
    }
  );
  const pdfBlob = new Blob([response.data as unknown as BlobPart], {
    type: "application/pdf",
  });
  return window.URL.createObjectURL(pdfBlob);
};

export const pdfService = {
  pdfStream,
  pdfFile,
};
